module.exports = __webpack_public_path__ + "img/appbg.474460c4.png";